'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const SessionExpiredError=require('../../../../dist-es6/client/services/errors/sessionExpiredError');
const{HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const LoginModalConfig=require('./modals/loginModalConfig');let

LoginController=(_class=class LoginController extends BaseController{
constructor($modal,$state,$window,$timeout,userService,fatigueMeterTypeContentProviderService,uncaughtErrorHandler){
super(uncaughtErrorHandler);

this._$state=$state;
this._$window=$window;
this._$modal=$modal;
this._$timeout=$timeout;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
this._userService=userService;

this._destinationUrl=this._getDestinationIfValid();
if(!_.exists(this._destinationUrl)){
this._$state.params.return_to=null;
}

this._$timeout(()=>this._attemptToContinueOrGoToLogin());
}


async _attemptToContinueOrGoToLogin(){
await this._tryRefreshCurrentUserState();

if(_.exists(this._userService.currentUser)){
this._continueFromLogin();
return;
}

this._loginModalInstance=this._$modal.open(LoginModalConfig);
this._loginModalInstance.result.then(()=>this._continueFromLogin());
}


async _tryRefreshCurrentUserState(){
try{
await this._userService.continueUserSession();
}catch(e){
if(e instanceof SessionExpiredError){
return this._$timeout(()=>this._userService.clearAllUserData());
}

if("production"==='development'){
console.error(e);
}


}
}

_getDestinationIfValid(){
if(!_.exists(this._$state.params.return_to)){
return;
}

const destination=decodeURIComponent(this._$state.params.return_to);
const currentHost='https://'+this._$window.location.host;

if(!destination.startsWith(currentHost)||
destination.startsWith(currentHost+'/#/login')||
destination===currentHost+'/'){
return;
}

return destination;
}

_continueFromLogin(){
if(_.exists(this._destinationUrl)){
this._$window.location=this._destinationUrl;
return;
}

this._$state.go(this._fatigueMeterTypeContentProviderService.defaultFeature);
}},(_applyDecoratedDescriptor(_class.prototype,'_attemptToContinueOrGoToLogin',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_attemptToContinueOrGoToLogin'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_tryRefreshCurrentUserState',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_tryRefreshCurrentUserState'),_class.prototype)),_class);


module.exports=LoginController;
//# sourceMappingURL=loginController.js.map
